import { fetchRequest } from "@/plugins/fetchRequest";

const actions = {
  list({ commit }: StoreProp, { status, name }: UnknownObj) {
    const params: string[] = [];
    if (status) {
      params.push(`status=${status}`);
    }

    if (name) {
      params.push(`client.qname=${name}`);
    }

    return new Promise((resolve, reject) => {
      fetchRequest({ url: `users?${params.join("&")}` })
        .then((responseData = {}) => {
          const users: Profile[] = responseData?.data || responseData;
          if (commit) {
            commit("USERS_UPDATE", users);
            resolve(users);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  add({ commit }: StoreProp, { profile = {} }: UnknownObj) {
    return new Promise((resolve, reject) => {
      fetchRequest({
        method: "post",
        url: "users",
        body: profile as BodyInit
      })
        .then((responseData = {}) => {
          const profile: Profile = responseData?.data || responseData;
          if (commit) {
            resolve(profile);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  edit({ commit }: StoreProp, { id, profile = {} }: UnknownObj) {
    return new Promise((resolve, reject) => {
      fetchRequest({
        method: "put",
        url: `users/${id}`,
        body: profile as BodyInit
      })
        .then((responseData = {}) => {
          const profile: Profile = responseData?.data || responseData;
          if (commit) {
            resolve(profile);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  remove({ commit }: StoreProp, partnerId: string) {
    return new Promise((resolve, reject) => {
      fetchRequest({
        method: "delete",
        url: `users/${partnerId}`
      })
        .then((responseData = {}) => {
          const response: UnknownObj = responseData?.data || responseData;
          if (commit) {
            resolve(response);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  }
};

export default actions;
